// Clears the rejected token and keeps the current URL so login can return to it.
export function redirectToLogin(): void {
    localStorage.removeItem('odo_login_token');
    const from =
        globalThis.location.pathname + globalThis.location.search + globalThis.location.hash;
    const suffix = from && from !== '/' ? `?from=${encodeURIComponent(from)}` : '';
    globalThis.location.href = `/login${suffix}`;
}
